module.exports = __webpack_public_path__ + "static/media/share.e92385d9.svg";